import { Badge } from "./Badge";
export { Badge };
export default Badge;
